// HomeShowcaseList.js
import { connect } from 'react-redux';

import changeShowcaseActiveIndex from '../action/changeShowcaseActiveIndex.js';
import changeShowcaseSize from '../action/changeShowcaseSize.js';
import fetchFeeds from '../action/fetchFeeds.js';
import getShowcaseListItems from '../selector/getShowcaseListItems.js';
import getOperationData from '../selector/getOperationData.js';
import getShowcaseListIndexes from '../selector/getShowcaseListIndexes.js';
import getMeData from '../selector/getMeData.js';
import HomeShowcaseList from '../component/HomeShowcaseList.jsx';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import { SHOWCASE_FEED } from '../RemoteConfigKeys.js';

const mapStateToProps = state => {
  const showcaseFeed = getRemoteConfigData(state, SHOWCASE_FEED);
  return {
    showcaseFeed,
    itemIds: getShowcaseListItems(state, showcaseFeed),
    indexes: getShowcaseListIndexes(state, showcaseFeed),
    activeIndex: getOperationData(state, ['showcase'], 'activeIndex'),
    itemAmount: getOperationData(state, ['showcase'], 'itemAmount'),
    itemWidth: getOperationData(state, ['showcase'], 'itemWidth'),
    itemHeight: getOperationData(state, ['showcase'], 'itemHeight'),
    isAuthed: !!getMeData(state, 'id'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    changeActiveIndex: data => dispatch(changeShowcaseActiveIndex(data)),
    changeShowcaseSize: data => dispatch(changeShowcaseSize(data)),
    fetchFeeds: data => dispatch(fetchFeeds(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  // equals to `{ ...ownProps, ...stateProps, ...dispatchProps }`
  // ref: https://github.com/reduxjs/react-redux/blob/v7.1.0/src/connect/mergeProps.js
  null,
  { forwardRef: true } // Required by WithIntersectionObserver
)(HomeShowcaseList);
